import gql from 'graphql-tag';

export const _AGING_BALANCE = gql`
query gqlDashboard_agingBalance(
	$participant: uuid!
	$legal_entity: uuid
	$today: date!
	$today_minus_30: date!
	$today_minus_60: date!
	$today_minus_90: date!
	$issue_date_from: date!
	$issue_date_until: date!
  ) {
	not_overdue: risolto_accounting_document_aggregate(
	  where: {
		participant: { _eq: $participant }
		_or: [
			{ legal_entity: { _eq: $legal_entity } },
			{ legal_entity: { _is_null: true } }
		]
		due_date: { _gt: $today }
		document_type: { _in: ["INVOICE", "CREDIT_NOTE", "DEBIT_NOTE"] }
		_and: [
		  { issue_date: { _gte: $issue_date_from } }
		  { issue_date: { _lt: $issue_date_until } }
		]
	  }
	) {
	  aggregate {
		sum {
		  open_amount
		}
	  }
	}
	days30: risolto_accounting_document_aggregate(
	  where: {
		participant: { _eq: $participant }
		_or: [
			{ legal_entity: { _eq: $legal_entity } },
			{ legal_entity: { _is_null: true } }
		]
		_and: [
		  { _or: [
			{
				_and: [
					{ due_date: { _lte: $today } }
					{ due_date: { _gte: $today_minus_30 } }
				] 
			}
			{ due_date: { _is_null: true } }  # payments
		  ] }
		  { issue_date: { _lte: $issue_date_until } }
		  { issue_date: { _gte: $issue_date_from } }
		]
	  }
	) {
	  aggregate {
		sum {
		  open_amount
		}
	  }
	}
	days60: risolto_accounting_document_aggregate(
	  where: {
		participant: { _eq: $participant }
		_or: [
			{ legal_entity: { _eq: $legal_entity } },
			{ legal_entity: { _is_null: true } }
		]
		_and: [
			{ _or: [
				{ _and: [
					{ due_date: { _lt: $today_minus_30 } }
					{ due_date: { _gte: $today_minus_60 } }
				] }
				{ due_date: { _is_null: true } }  # payments
			] }
			{ issue_date: { _lt: $issue_date_until } }
			{ issue_date: { _gte: $issue_date_from } }
		]
	  }
	) {
	  aggregate {
		sum {
		  open_amount
		}
	  }
	}
	days90: risolto_accounting_document_aggregate(
	  where: {
		participant: { _eq: $participant }
		_or: [
			{ legal_entity: { _eq: $legal_entity } },
			{ legal_entity: { _is_null: true } }
		]
		_and: [
			{ _or: [
				{ _and: [
					{ due_date: { _lt: $today_minus_60 } }
					{ due_date: { _gte: $today_minus_90 } }
				] }
				{ due_date: { _is_null: true } }  # payments
			] }
			{ issue_date: { _lt: $issue_date_until } }
			{ issue_date: { _gte: $issue_date_from } }
		]
	  }
	) {
	  aggregate {
		sum {
		  open_amount
		}
	  }
	}
	days90plus: risolto_accounting_document_aggregate(
	  where: {
		participant: { _eq: $participant }
		_or: [
			{ legal_entity: { _eq: $legal_entity } },
			{ legal_entity: { _is_null: true } }
		]
		_and: [
			{ _or: [
				{ _and: [
					{ due_date: { _lt: $today_minus_90 } }
				] }
				{ due_date: { _is_null: true } }  # payments
			] }
			{ issue_date: { _lt: $issue_date_until } }
			{ issue_date: { _gte: $issue_date_from } }
		]
	  }
	) {
	  aggregate {
		sum {
		  open_amount
		}
	  }
	}
  }  
`;

export const _AGING_BALANCE_RECIPIENT = gql`
query gqlDashboard_agingBalanceRecipient(
	$participant: uuid!
	$recipient: uuid!
	$today: date!
	$today_minus_30: date!
	$today_minus_60: date!
	$today_minus_90: date!
  ) {
	not_overdue: risolto_accounting_document_aggregate(
	  where: {
		recipient: { _eq: $recipient }
		participant: { _eq: $participant }
		due_date: { _gt: $today }
	  }
	) {
	  aggregate {
		sum {
		  open_amount
		  total_amount
		}
	  }
	}
	days30: risolto_accounting_document_aggregate(
	  where: {
		recipient: { _eq: $recipient }
		participant: { _eq: $participant }
		_or: [
			{ _and: [
				{ due_date: { _lt: $today_minus_30 } }
				{ due_date: { _gte: $today_minus_60 } }
			] }
			{ due_date: { _is_null: true } }  # payments
		]
	  }
	) {
	  aggregate {
		sum {
		  open_amount
		  total_amount
		}
	  }
	}
	days60: risolto_accounting_document_aggregate(
	  where: {
		recipient: { _eq: $recipient }
		participant: { _eq: $participant }
		_or: [
			{ _and: [
				{ due_date: { _lt: $today_minus_30 } }
				{ due_date: { _gte: $today_minus_60 } }
			] }
			{ due_date: { _is_null: true } }  # payments
		]
	  }
	) {
	  aggregate {
		sum {
		  open_amount
		  total_amount
		}
	  }
	}
	days90: risolto_accounting_document_aggregate(
	  where: {
		recipient: { _eq: $recipient }
		participant: { _eq: $participant }
		_or: [
			{ _and: [
				{ due_date: { _lt: $today_minus_60 } }
				{ due_date: { _gte: $today_minus_90 } }
			] }
			{ due_date: { _is_null: true } }  # payments
		]
	  }
	) {
	  aggregate {
		sum {
		  open_amount
		  total_amount
		}
	  }
	}
	days90plus: risolto_accounting_document_aggregate(
	  where: {
		recipient: { _eq: $recipient }
		participant: { _eq: $participant }
		_or: [
			{ _and: [
				{ due_date: { _lt: $today_minus_90 } }
			] }
			{ due_date: { _is_null: true } }  # payments
		]
	  }
	) {
	  aggregate {
		sum {
		  open_amount
		  total_amount
		}
	  }
	}
  }  
`;
